module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/sec01_pc_bdac6b0a9dbc78d61d3230398646d48e.jpg";